export default "__VITE_ASSET__BDDtHogv__"